module.exports = __webpack_public_path__ + "img/hasselt-1.4a6e43f0.jpg";